import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { IconButton } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import { toast } from 'react-toastify';
import Grow from '@material-ui/core/Grow';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Grow ref={ref} {...props} />;
});

const initialFormState = { 
	id: null, 
	firstName: "",
  lastName:"",
  email: "",
  mobile: ""
}

const FormDialogEditUser = (props) => {
  const [open, setOpen] = useState(false);
  const [user, setUser] = useState(initialFormState);
  const [errors, setErrors ] = useState({})

  const handleClickOpen = () => {
      setErrors({});
      setUser({
        id : props.dataUser[0],
        firstName : props.dataUser[1],
        lastName : props.dataUser[2],
        email : props.dataUser[3],
        mobile : props.dataUser[4],
        role: "admin"
      })
      setOpen(true);
  }

  const handleClose = () => {
      setOpen(false);
  }

  const handleInputChange = event => {
		const { name, value } = event.target
    setUser({ ...user, [name]: value })
  }
  
  const validate = () => {
      let tempErrors = {};
      let formIsValid = true;

      if(!user.firstName || user.firstName.trim() ===  ""){
        formIsValid = false;
        tempErrors["firstName"] = "Cannot be empty";
      }

      if(!user.lastName || user.lastName.trim() ===  ""){
        formIsValid = false;
        tempErrors["firstName"] = "Cannot be empty";
      }
      if(!user.mobile || user.mobile.trim() ===  ""){
        formIsValid = false;
        tempErrors["mobile"] = "Cannot be empty";
      }

      if(!user.email || user.email.trim() ===  ""){
        formIsValid = false;
        tempErrors["email"] = "Cannot be empty";
      }

      let regexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      // let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (!regexp.test(user.email)) {
        formIsValid = false;
        tempErrors["email"] = "Email is not valid";
      }

      setErrors(tempErrors);
      return formIsValid;
  }

  const handleSubmit = (e) => {
      const onSuccess = () => {
          setOpen(false);
          toast.success('Data succesfully updated');
      }
      e.preventDefault();

      if(validate()){
        props.update(user.id, user, onSuccess)
      }
  }

  return (
    <div>
      <IconButton color="primary" onClick={handleClickOpen}>
          <EditIcon />
      </IconButton>
      <Dialog  
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        aria-labelledby="form-dialog-title"
      >
            <DialogTitle id="form-dialog-title" style={{padding: "30px 30px 0px 30px"}}>Edit User</DialogTitle>

            <DialogContent style={{padding: "30px 30px 10px 30px"}}>
                
                <TextField
                  autoFocus
                  name="firstName"
                  label="First Name"
                  value={user.firstName}
                  fullWidth
                  onChange={handleInputChange}
                  {...(errors.firstName && { error: true, helperText: errors.firstName })}
                />

                <TextField
                  
                  name="lastName"
                  label="Last Name"
                  value={user.lastName}
                  fullWidth
                  onChange={handleInputChange}
                  {...(errors.lastName && { error: true, helperText: errors.lastName })}
                />

                <br /><br />

                <TextField
                  name="email"
                  label="Email"
                  value={user.email}
                  fullWidth
                  onChange={handleInputChange}
                  {...(errors.email && { error: true, helperText: errors.email })}
                />

            </DialogContent>

            <DialogActions style={{padding: 30}}>
                <Button variant="contained" onClick={handleClose} color="primary">
                    Cancel
                </Button>
                <Button variant="contained" onClick={handleSubmit} color="secondary">
                    Save
                </Button>
            </DialogActions>

      </Dialog>
    </div>
  );
}

export default FormDialogEditUser;